var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinCode({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 58,
    viewBox: "0 0 152 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1074_5478)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.0901,
    y: 5.82447,
    width: 27.1441,
    height: 36.5856,
    rx: 4.13063,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.18018
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.3157,
    y: 5.82447,
    width: 27.1441,
    height: 36.5856,
    rx: 4.13063,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.18018
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.5403,
    y: 5.82447,
    width: 27.1441,
    height: 36.5856,
    rx: 4.13063,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.18018
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.766,
    y: 5.82447,
    width: 27.1441,
    height: 36.5856,
    rx: 4.13063,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.18018
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5183 28.9129L23.7248 25.716L21.0483 27.5085L19.9414 25.559L22.8244 24.1547L19.9414 22.7503L21.0483 20.8008L23.7248 22.5934L23.5183 19.3965H25.7404L25.5257 22.5934L28.2021 20.8008L29.3091 22.7503L26.4343 24.1547L29.3091 25.559L28.2021 27.5085L25.5257 25.716L25.7404 28.9129H23.5183Z",
    fill: "#2F32FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7439 28.9129L57.9504 25.716L55.2739 27.5085L54.167 25.559L57.05 24.1547L54.167 22.7503L55.2739 20.8008L57.9504 22.5934L57.7439 19.3965H59.966L59.7513 22.5934L62.4277 20.8008L63.5347 22.7503L60.6599 24.1547L63.5347 25.559L62.4277 27.5085L59.7513 25.716L59.966 28.9129H57.7439Z",
    fill: "#2F32FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9685 28.9129L92.175 25.716L89.4985 27.5085L88.3916 25.559L91.2746 24.1547L88.3916 22.7503L89.4985 20.8008L92.175 22.5934L91.9685 19.3965H94.1906L93.9759 22.5934L96.6523 20.8008L97.7593 22.7503L94.8845 24.1547L97.7593 25.559L96.6523 27.5085L93.9759 25.716L94.1906 28.9129H91.9685Z",
    fill: "#2F32FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.194 28.9129L126.401 25.716L123.724 27.5085L122.617 25.559L125.5 24.1547L122.617 22.7503L123.724 20.8008L126.401 22.5934L126.194 19.3965H128.416L128.201 22.5934L130.878 20.8008L131.985 22.7503L129.11 24.1547L131.985 25.559L130.878 27.5085L128.201 25.716L128.416 28.9129H126.194Z",
    fill: "#2F32FE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1074_5478",
    x: 0.5,
    y: 0.234375,
    width: 151,
    height: 57.7656,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.184314 0 0 0 0 0.196078 0 0 0 0 0.996078 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1074_5478"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1074_5478",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinCode);
export default __webpack_public_path__ + "static/media/pin-code.3317c1a6.svg";
export { ForwardRef as ReactComponent };